/* ============================================================
   ToTheLove — Macarons vidéo : modale stories (V2)
   ------------------------------------------------------------
   Vanilla JS, zéro dépendance. Scoping strict sur
   [data-ttl-macarons] pour ne jamais interférer avec Recharge
   ou d'autres composants (leçon du bug Turbo : pas de sélecteur
   global non scopé).
   ============================================================ */
(function () {
  'use strict';

  function initMacarons(root) {
    if (!root || root.__ttlInit) return;
    root.__ttlInit = true;

    var triggers = root.querySelectorAll('[data-ttl-macaron]');
    var modal = root.querySelector('[data-ttl-modal]');
    if (!modal || !triggers.length) return;

    // PORTAL : sortir la modale du conteneur <product-info> et l'attacher
    // au <body>. Sinon le position:fixed est piégé dans le contexte
    // d'empilement de product-info (la modale bloque le scroll mais
    // reste invisible / derrière la colonne produit).
    if (modal.parentNode !== document.body) {
      // évite les doublons si la section est rechargée (Theme Editor)
      if (modal.id) {
        var dup = document.body.querySelector('#' + modal.id + '[data-ttl-modal]');
        if (dup && dup !== modal) dup.remove();
      }
      document.body.appendChild(modal);
    }

    var slides = modal.querySelectorAll('[data-ttl-slide]');
    var prevBtn = modal.querySelector('[data-ttl-prev]');
    var nextBtn = modal.querySelector('[data-ttl-next]');
    var closeEls = modal.querySelectorAll('[data-ttl-close]');
    var current = -1;
    var lastFocused = null;

    function total() {
      return slides.length;
    }

    function pauseAll() {
      modal.querySelectorAll('[data-ttl-video]').forEach(function (v) {
        try {
          v.pause();
          v.currentTime = v.currentTime; // garde la position, pas de reset brutal
        } catch (e) {}
      });
    }

    function showSlide(index) {
      if (index < 0 || index >= total()) return;
      pauseAll();
      slides.forEach(function (s, i) {
        var active = i === index;
        s.hidden = !active;
      });
      current = index;
      updateNav();
      // joue la vidéo active
      var active = slides[index];
      var vid = active && active.querySelector('[data-ttl-video]');
      if (vid) {
        // léger délai pour laisser le DOM s'afficher
        window.setTimeout(function () {
          var p = vid.play();
          if (p && typeof p.catch === 'function') {
            p.catch(function () {}); // autoplay bloqué : l'utilisateur cliquera play
          }
        }, 80);
      }
    }

    function updateNav() {
      if (prevBtn) prevBtn.disabled = current <= 0;
      if (nextBtn) nextBtn.disabled = current >= total() - 1;
    }

    function openModal(index) {
      lastFocused = document.activeElement;
      modal.hidden = false;
      // Compense la largeur de la scrollbar pour éviter le saut d'écran
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      if (sbw > 0) {
        document.body.style.paddingRight = sbw + 'px';
      }
      document.documentElement.classList.add('ttl-modal-open');
      showSlide(index);
      // focus sur le bouton fermer pour l'accessibilité
      var c = modal.querySelector('[data-ttl-close]');
      if (c) c.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function closeModal() {
      pauseAll();
      modal.hidden = true;
      document.documentElement.classList.remove('ttl-modal-open');
      document.body.style.paddingRight = '';
      slides.forEach(function (s) { s.hidden = true; });
      current = -1;
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        closeModal();
      } else if (e.key === 'ArrowRight') {
        if (current < total() - 1) showSlide(current + 1);
      } else if (e.key === 'ArrowLeft') {
        if (current > 0) showSlide(current - 1);
      }
    }

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-ttl-index'), 10) || 0;
        openModal(idx);
      });
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (current > 0) showSlide(current - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (current < total() - 1) showSlide(current + 1);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-ttl-macarons]').forEach(initMacarons);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Réinitialise dans l'éditeur de thème Shopify (section rechargée)
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-ttl-macarons]');
    if (root) initMacarons(root);
  });
})();